import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import CargoCorporateCredit from './CargoCorporateCredit';
import TicketCorporateCredit from './TicketCorporateCredit';
import ManualVoucherPayment from './ManualVoucherPayment';

export default combineReducers({
  UnitHome,
  CargoCorporateCredit,
  TicketCorporateCredit,
  ManualVoucherPayment,
});
